import { NavLink } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import { FiSidebar } from "react-icons/fi";

export default function SidebarUser({ collapsed, setCollapsed }) {

  function getActive(path) {
    const currentPath = window.location.hash.replace(/^#/, "");
    return currentPath === path;
  }

  const handleNavClick = (e, path) => {
    if (collapsed) {
      e.preventDefault(); // stop instant navigation
      setCollapsed(false); // open sidebar first

      setTimeout(() => {
        window.location.hash = path; // navigate after animation
      }, 300);
    }
  };

  const menu = [
    {
      name: "My Team",
      path: "/insight/coachpanel",
      isActive: getActive("/insight/coachpanel"),
      icon: <AiOutlineHome size={24} />,
    }
  ];

  return (
    <>
      {/* SIDEBAR */}
      <aside
        className={`fixed top-0 left-0 z-50 h-screen bg-[#f9fafb] border-r
        flex flex-col
        transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]

        ${collapsed ? "md:w-20" : "md:w-64"} 
        w-64

        ${collapsed ? "-translate-x-full md:translate-x-0" : "translate-x-0"}
      `}
      >
        {/* HEADER */}
        <div className="md:px-4 px-2 py-5 flex items-center justify-between">
          {!collapsed && (
            <div className="text-2xl font-bold">
              <img src="/insight/insightplus_logo.svg" alt="logo" className="h-10" />
            </div>
          )}

          <button
            onClick={() => setCollapsed(!collapsed)}
            className="hidden md:flex p-2 rounded-lg transition-all duration-300
            hover:bg-indigo-100 hover:text-indigo-600"
          >
            <FiSidebar
              size={24}
              className={`transition-transform duration-300 ${collapsed ? "rotate-180" : ""
                }`}
            />
          </button>
        </div>

        {/* MENU */}
        <nav className="md:px-3 px-2 space-y-2 mt-3">
          {menu.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={(e) => handleNavClick(e, item.path)}
              className={() =>
                `group flex items-center
                ${collapsed ? "justify-center px-2" : "gap-3 px-3"}
                py-3 rounded-lg text-base font-medium
                transition-all duration-300 ease-in-out
                ${item.isActive
                  ? "bg-indigo-100 text-indigo-600"
                  : "textblack hover:bg-indigo-100 hover:text-indigo-600"
                }`
              }
            >
              {/* ICON */}
              <span className="flex items-center justify-center min-w-[24px]">
                {item.icon}
              </span>

              {/* TEXT */}
              <span
                className={`whitespace-nowrap overflow-hidden
                transition-all duration-300
                ${collapsed ? "opacity-0 w-0" : "opacity-100 w-auto"}
              `}
              >
                {item.name}
              </span>
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* MOBILE OVERLAY */}
      {!collapsed && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={() => setCollapsed(true)}
        />
      )}
    </>
  );
}